import type { communications as en } from '@/i18n/locales/en/communications';
import type { Translation } from '@/i18n/types';

export const communications: Translation<typeof en> = {
  page: {
    title: 'İletişim',
    lead: '{{company}} için bildirim oluşturun ve planlayın.',
    noScope: 'İletişimini görmek için bir şirket seçin.',
    forbidden: 'Bu şirketin iletişimini görmenize izin verilmiyor.',
  },
  composer: {
    title: 'Yeni bildirim',
    titleField: 'Başlık',
    message: 'Mesaj',
    category: 'Kategori',
    audience: 'Hedef kitle',
    date: 'Tarih',
    time: 'Saat',
    callToAction: 'Eylem çağrısı',
    quietHours: 'Sessiz saatlere uy',
    quietHoursHint: '08:00–20:00 dışında teslimatı ertele.',
    submit: 'Taslak olarak kaydet',
    schedule: 'Planla',
    send: 'Şimdi gönder',
  },
  categories: {
    algemeen: 'Genel',
    veiligheid: 'Güvenlik',
    evenement: 'Etkinlik',
    vitaliteit: 'Canlılık',
    hr: 'İK',
  },
  audiences: {
    iedereen: 'Herkes',
    management: 'Yönetim',
    per_afdeling: 'Departmana göre',
    per_locatie: 'Konuma göre',
  },
  status: {
    concept: 'Taslak',
    ingepland: 'Planlandı',
    verzonden: 'Gönderildi',
  },
  log: {
    title: 'Gönderim günlüğü',
    empty: 'Henüz iletişim yok.',
    columns: {
      message: 'Mesaj',
      category: 'Kategori',
      reach: 'Erişim',
      openRate: 'Açılma oranı',
      status: 'Durum',
    },
  },
  actions: {
    new: 'Yeni bildirim',
    cancel: 'İptal',
    markScheduled: 'Planlandı olarak işaretle',
    markSent: 'Gönderildi olarak işaretle',
  },
};
